/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	message: {
		hello: 'hello világ'
	},
	home: {
		slogan: "Asztma naplózás az orvosoddal",
		intro: "A Pulmoment egy mobil program volt asztmás betegek és orvosaik számára. A projektet 2016 és 2018 között egy csapat hallgató fejlesztette az Eötvös Loránd Tudományegyetem Informatikai Karán, Dr. Szánthó András tüdőgyógyász szakorvos közreműködésével. A szoftver támogatása 2023-ban véget ért, de reméljük, hogy munkánk segítségével jobb egészségügyi megoldások születnek a jövőben. Köszönettel tartozunk a felhasználóinknak és az egészségügyi szakembereknek a támogatásukért.",
		supportTitle: "Támogatóink",
		introtitle:"Állapot naplózás, egyszerűen",
		featurefirst: "Közvetlen kapcsolat az orvossal",
		featurefirstdesc: "A programon keresztül üzenetet küldhetsz az orvosodnak, értesítést kap a kritikus tünetekről és valós időben látja az állapotod változását.",
		featuresecond: "Kérdések, szükség esetén",
		featureseconddesc: "Nem minden beteg egyforma, ezért a rendszer figyelembe veszi a mért adatokat, hogy ez alapján csak akkor kelljen kitölteni az állapotfelmérőt, ha tényleg szükséges.",
		featurethird: "Állapotváltozás előrejelzések",
		featurethirddesc: "A folyamatos kérdéssoroknak alapján nem csak a hosszú távú egészségügyi adatokat tekinthetik át a betegek, hanem kimutatásokat is kapnak a várható tünetekről és a kritikus időszakokról.",
		featurefourth: "Vizit időpont kezelés",
		featurefourthdesc: "A mobil alkalmazás figyelmezetést küld a közelgő találkozókról, és ha épp időpontváltozás vagy helyettesítés befolyásolja a kapott időpontot.",
		doctorslogan: "Összkép a páciensekről, egy gombnyomásra.",
		doctorregistrate: "Regisztáljon ingyenesen az alábbi linken, hogy még jobb rálátást kapjon a betegei állapotáról:",
		doctorregistrateinfo: "Elég megadnia egy email címet vagy egy telefonszámot, és a csapatunk személyesen felkeresi a profilja beállítása miatt.",
		specialThanks: "Külön köszönet a sok segítségért:",
		titleDaniel: "Projekt vezető, szoftverfejlesztő",
		titleLevente: "Mobil alkalmazás fejlesztő",
		titleAndras: "Egészségügyi szakértő",
		titleJulia: "Marketing és sales",
		titleMano: "PR és technológiai segítségnyújtás",
		titleFanni: "Web alkalmazás fejlesztő",
		titleDamiano: "Üzletfejlesztő",
		videotitle: "Nézd meg a gyakorlatban",
		fbtwitter: "Kövess minket <a href=\"https://www.facebook.com/pulmoment/\" target=\"_blank\">Facebookon</a> és <a href=\"https://twitter.com/pulmoment\" target=\"_blank\">Twitteren</a> további hírekkel kapcsolatban."
	},

	milestones:{
		"title": "Mérföldkövek",
		"intro":{
			"date": "2016 tavasz",
			"title": "Elindultunk",
			"desc": "A tervezési fázis kezdete az asztmás viziteket érintő nehézségek alapján. Ekkor még Symbimed név alatt működött a csapatunk, 2016 nyarán váltottunk a Pulmoment névre, ami könnyebben érthető és jobban tükrözi a céljainkat."
		},
		"elte":{
			"date": "2016.05.11.",
			"title": "ELTE Innovatív Hallgatói Ötletpályázat",
			"desc": "Az ötletünket első helyen díjazta a 2016-os hallgatói pályázatán az ország legnagyobb egyeteme. Csapatunk az Informatikai Karon állt össze és büszkék vagyunk arra, hogy ELTE-s emberekkel együtt dolgozunk. A jövőben is folyamatosan kooperálunk az egyetemmel kutatási és fejlesztési tevékenységekben."
		},
		"district":{
			"date": "2016.05.17.",
			"title": "Újbudai Hallgatói Startup Pályázat",
			"desc": "A projektet az újbudai önkormányzat elismerésben részesítette. Hiszünk benne, hogy Újbuda a főváros leginnovatívabb kerülete, a jelentős mennyiségű informatikai cég és egyetemek jelenlétének köszönhetően. Ez a fő oka annak, hogy itt pozicionáltuk a termékünk fejlesztését."
		},
		"pediatricBeta":{
			"date": "2016.11.04.",
			"title": "52. Gyermektüdőgyógyász Konferencia - Első publikus béta verzió",
			"desc": "A rendezvényen során bemutattuk a Pulmoment első publikus béta verzióját, a betegeknek és orvosoknak szánt felülettel egyaránt. Első alkalommal prezentálhattunk közvetlenül tüdőgyógyász közönségnek és a visszajelzések megerősítették a szolgáltatásunk jelentőségét."
		},
		"pilotRelease":{
			"date": "2017.04.27.",
			"title": "Első publikus kiadás",
			"desc": "Megjelent a Pulmoment első kiadásra szánt verziója, pilot fázisban. Elsőként Magyarországon teszteljük egy kontrollcsoport segítségével, miközben új funkciók fejlesztésén dolgozunk."
		},
		"gitr":{
			"date": "2017.05.12.",
			"title": "Get in the Ring - Chengdu",
			"desc": "Az Enterprise Hungary és a Magyar Nemzeti Kereskedőház kiválasztotta a Pulmomentet a négy magyar csapat közé, akik Kínában versenyezhetnek a Get in the Ring startup versenyen. Végül a fődíjat egy kínai csapat vitte el, de a rendezvényen után nagyon sokat tanultunk a helyi kultúráról és az egészségügy helyzetéről. Kínában a krónikus tüdőbetegek száma rendkívüli méretű, emiatt a szolgáltatásunk nagyon hasznos megoldást jelenthet állami és privát irányból is. Ezzel egy helyi orvos csapat is egyetértett és biztosítottak a támogatásukról."
		},
		"beSmart":{
			"date": "2017.06.22.",
			"title": "Hungarian e-Health Day - Düsseldorf",
			"desc": "A Budapesti Vállalkozásfejlesztési Közalapítvány lehetőséget biztosított a termékünk németországi bemutatására, a Hungarian e-Health Day keretein belül. A Düsseldorfban megrendezett helyi versenyen a Pulmoment második helyet ért el. Emellett, egy kiváló programsorozat keretén belül megismerhettük a régió egészségügyi innovációt és a nemzetközi startupok számára biztosított lehetőségeket."
		},
		"ministry":{
			"date": "2017.07.14.",
			"title": "A Hónap Startupja díj",
			"desc": "A Nemzetgazdasági Minisztérium a Pulmomentnek ítélte a júniusi Hónap Startup Vállakozása elismerést."
		},
		"now":{
			"date": "Most",
			"title": "Haladunk tovább",
			"desc": "Folyamatosan keresünk tüdőgyógyászokat, kutatóintézményeket és egészségügyi szervezeteket akik nyitottak közreműködésre a hatékonyabb kezelés gyakorlati megvalósításához. Ha egyetért a céljainkkal, lépjen velünk kapcsolatban további információkért."
		}
	},

	admin: {
		edit_news: "Hír szerkesztő",
		editnews_note: "Az alábbi oldalon rövid híreket írhat a páciensei számára, általános információkkal vagy a rendeléssel kapcsolatban.",
		title: "Cím",
		content: "Tartalom",
		image: "Kép",
		general: "Általános",
		change_appointment: "Időpontváltozás",
		substitution: "Helyettesítés",
		release: "Publikálva",
		save: "Mentés",
		discipline: "Szakterület",
		facebook_link: "Facebook oldal címe",
		website: "Weboldal",
		healthcareId: "Egészségügyi nyilvántartási szám",
		add_new: "Új hozzáadása",
		needsignin: "Az oldal megjelenítéshez bejelentkezés szükséges",
		current: "Aktuális",
		consultinghours: "Hamarosan megadhatja rendelési idejét is a rendszerünkben.",
		nextoverall: "Következő összefoglaló",
		novisit: "Nem található következő vizit",
		totalizedsymptoms: "Összesített tünetek száma az elmúlt hónapban",
		allpatients: "Összes páciens",
		filledinspector: "Kitöltött havi állapotfelmérők",
		noinspector: "Még nincsenek kitöltött állapotfelmérők",
		newpatients: "Frissen regisztrált páciensek",
		rescueMedUsage: "Tüneti szer használat",
		summary: "Összesítés",
		numberofsymptoms: "Tünetek száma",
		lastFourWeek: "elmúlt négy hét",
		symptom: "Tünet",
		data: "Adatok",
		patientspage: "Páciens adatlap",
		mothersname: "Anyja neve:",
		socialsecuritynumber: "TAJ szám:",
		medicines: "Gyógyszerek:",
		printsummary: "Állapot összefoglaló nyomtatása",
		findinspector: "Kontroll kérdések küldése",
		useofmedicines: "Gyógyszerhasználat",
		rescueMedSymptom: "Tünetek and tüneti gyógyszerhasználat",
		factor: "Faktor",
		value: "Érték",
		tendency: "Tendencia",
		patients: "Páciensek",
		doctors: "Orvosok",
		descinfo: "A mobil alkalmazásban bármikor elérhetik az adatait a páciensek, tehát csak olyan információt adjon meg, amit meg szeretne osztani másokkal.",
		doctorspage: "Orvosi felület",
		sendfeedback: "Visszajelzés küldése",
		feedbackinfo: "Küld el nekünk véleményedet az alkalmazás használatával kapcsolatban.Ugyanitt jelezheted ha hibát találtál a szoftverben vagy az egészségügyi naplózás folyamatában.",
		phonenumber: "Telefonszám",
		message: "Üzenet",
		monthlyReport: "Havi bontás",
		dailyReport: "Napi bontás"
	},

	for_patients: "Pácienseknek",
	doctors: "Orvosoknak",
	see_more: "Tovább",
	read_more: "Tovább",
	contact_us: "Lépjen velünk kapcsolatba:",
	contact_us_directly: "Lépjen velünk kapcsolatba közvetlenül:",
	app_links: "A Pulmoment elérhető Android és iOS eszközökre:",
	thank_you: "2023-ban a Pulmoment fejlesztése véget ért és nem elérhető az alkalmazásboltokban.",

	report_feedback: "Hibabejelentés, visszajelzés küldése vagy egyéb megkeresés esetén.",
	contact: "Kapcsolatfelvétel",
	sign_in: "Bejelentkezés",
	sign_out: "Kijelentkezés",
	email: "E-mail",
	password: "Jelszó",
	cancel: "Mégsem",
	home_page: "Főoldal",
	patients: "Páciensek",
	profile: "Profilom",
	news: "Hírek",
	report_problem: "Hibajelentés",
	signin_note: "Ezen a felületen kizárólag az orvosok számára biztosítunk belépést. A páciensek elérhetik az alkalmazásunkat az App Store vagy a Google Play felületén. Ha még nem regisztrált a rendszerünkbe, az alábbi linken ingyenesen megteheti:",
	registration: "Regisztráció",
	name: "Név",
	attributes: "Jellemzők",
	introduction: "Bemutatkozás",
	contact_name: "Elérhetőség neve",
	contact_data: "Elérhetőség adata",
	peakflowmeter: "Csúcsáramlásmérő",
	peakflowmeterinfo: "A csúcsáramlásmérőt otthoni körülmények közt is használhatja. Segítségével már a tünetek megjelenése előtt kimutatható a légúti szűkület kisfokú növekedése is. Az asztmás rohamot előrejelezheti az, ha a mért értékek a szokásosnál alacsonyabbak. Ha a csúcsáramlás napi ingadozása meghaladja a 20 százalékot, az már asztmára utal, a 20-30 százaléknál is nagyobb változás pedig már súlyosabb gyulladást és obstrukciót jelez. Kérdezze meg orvosát, hogy mi a teendő ebben az esetben!",
	peakflowmeterlink: "Részletek:",


}



// WEBPACK FOOTER //
// ./src/strings/hu.js